import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CoreButton } from '../../../_core/components/_ui/core-button';
import { SurveyTemplateDto } from '@families-link/shared';
import { buttonHeaderStyles } from '../../../_core/styles';

export type CreateSurveyProps = {
	handleOpenModalCreate?: () => void;
};

export const CreateSurvey: FC<CreateSurveyProps> = (props) => {
	const { handleOpenModalCreate } = props;

	const [t] = useTranslation();

	return (
		<Box sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
			<Typography variant="h2" sx={{ fontSize: '16px', fontWeight: 500, my: '24px' }}>
				{t('surveys.survey-results')}
			</Typography>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					flexGrow: 1,
					flexWrap: 'wrap',
					margin: 'auto',
					gap: 4,
				}}
			>
				<Typography variant="h3" sx={{ fontSize: '16px', fontWeight: 500 }}>
					{t('surveys.create-title')}
				</Typography>
				<Box sx={{ width: '65%', textAlign: 'center' }}>
					<Typography variant="body1" sx={{fontSize: '14px'}}>{t('surveys.create-description')}</Typography>
				</Box>
				<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<CoreButton onClick={handleOpenModalCreate} sx={buttonHeaderStyles}>
						{t('surveys.choose-button')}
					</CoreButton>
				</Box>
			</Box>
		</Box>
	);
};
